import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCargotype = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={13} fill="none" {...props}>
    <path fill="#616061" d="M0 0h16v3H0zM5 5H1v8h14V5h-4v2H5z" />
  </svg>
);
export default SvgCargotype;
